export function SeedBadge({ show }) {
  if (!show) return null;
  return (
    <span
      data-testid="seed-badge"
      title="Demo-/Seed-Datensatz (keine echten Daten)"
      className="ml-2 inline-flex items-center rounded border border-status-warning-border bg-status-warning-bg px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wider text-status-warning"
    >
      DEMO
    </span>
  );
}
